import { LoyaltyLevelColorsInterface } from '../types'
import { LOYALTY_LEVEL_NAMES } from './levelNames'

export const DEFAULT_LOYALTY_LEVEL_NAME = LOYALTY_LEVEL_NAMES.level01

export const LOYALTY_LEVEL_COLORS: Record<LOYALTY_LEVEL_NAMES, LoyaltyLevelColorsInterface> = {
  [LOYALTY_LEVEL_NAMES.level01]: { accent: '#B1E400', contrast: 'black.0' },
  [LOYALTY_LEVEL_NAMES.level02]: { accent: '#3F42F6', contrast: 'white.0' },
  [LOYALTY_LEVEL_NAMES.level03]: { accent: '#9747FF', contrast: 'white.0' },
  [LOYALTY_LEVEL_NAMES.level04]: { accent: '#FFD92F', contrast: 'black.0' },
  [LOYALTY_LEVEL_NAMES.level05]: { accent: '#201E1F', contrast: 'brand.4' },
}
